
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Ferguson_classification_of_flexion_compression_fractures',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Orthopaedics/Ferguson_classification_of_flexion_compression_fractures.vue